angular.module('filters').filter('sanitizeEditorField', function() {
  return function(data, replaceSpaces, params) {
    var allowedTags, text, withBreaks;
    allowedTags = (params != null ? params.target : void 0) === 'subject' ? ['mark'] : ['mark', 'br', 'img'];
    withBreaks = data.replaceAll('\n', '<br/>').replace(/<p>/g, '<br/><p>').replace(/<div>/g, '<br/><div>').replace(/^<br\/>/g, '').replace(/<\/p><p>/g, '</p><br/><p>');
    text = $.htmlClean(withBreaks, {
      allowedTags: allowedTags
    }).replace(/(\S)<mark>{/g, '$1 <mark>{');
    if (replaceSpaces) {
      return text.replace(/&#160;/g, ' ');
    } else {
      return text;
    }
  };
});
